import { ObservableArray, View } from "binder"
import { ImageChooserViewModel, singleFile } from "./imageChooser-viewModel"

export class ImageChooserView extends View<ImageChooserViewModel>{
    GetViewUniqueId(): string {
        return "V-7A2B3B8F-45A0-4EF2-B8AF-C3948F70F548"
    }
    loadHtml(): string {
        let element = require('./imageChooser.html').default;
        let style = require('./imageChooser.less');
        return element;
    }
    constructor() {
       super();
    }

    public set files(v: ObservableArray<singleFile>) { this._files = v; } public get files(): ObservableArray<singleFile> { return this._files;} private _files: ObservableArray<singleFile>;
    public set capturedPicture(v: string) { this._capturedPicture = v; } public get capturedPicture(): string { return this._capturedPicture;} private _capturedPicture: string;
    addFile(){
        this.dataContext.addFile();
    }
    save(){
        this.dataContext.save();
    }
    back(){
        this.dataContext.back();
    }
}
